import { lazy } from 'react';
import { LegalPage } from '../components/LegalPage';

const TermsAndConditionsContent = lazy(() => import('../content/legal/terminos-y-condiciones.md'));
const PrivacyPolicyContent = lazy(() => import('../content/legal/politica-de-privacidad.md'));

export function TermsAndConditions() {
  return (
    <LegalPage title="Términos y condiciones">
      <TermsAndConditionsContent />
    </LegalPage>
  );
}

export function PrivacyPolicy() {
  return (
    <LegalPage title="Política de privacidad">
      <PrivacyPolicyContent />
    </LegalPage>
  );
}
